<div class="plus">
  <span class="text-3xl text-primary pi pi-plus"></span>
</div>
